import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '@/locales/en/common.json';
import enAuth from '@/locales/en/auth.json';
import enDashboard from '@/locales/en/dashboard.json';
import enDevices from '@/locales/en/devices.json';
import enEmployees from '@/locales/en/employees.json';
import enReports from '@/locales/en/reports.json';
import enAdmin from '@/locales/en/admin.json';
import enErrors from '@/locales/en/errors.json';
import enHolidays from '@/locales/en/holidays.json';
import enNotifications from '@/locales/en/notifications.json';
import enLanding from '@/locales/en/landing.json';

import ruCommon from '@/locales/ru/common.json';
import ruAuth from '@/locales/ru/auth.json';
import ruDashboard from '@/locales/ru/dashboard.json';
import ruDevices from '@/locales/ru/devices.json';
import ruEmployees from '@/locales/ru/employees.json';
import ruReports from '@/locales/ru/reports.json';
import ruAdmin from '@/locales/ru/admin.json';
import ruErrors from '@/locales/ru/errors.json';
import ruHolidays from '@/locales/ru/holidays.json';
import ruNotifications from '@/locales/ru/notifications.json';
import ruLanding from '@/locales/ru/landing.json';

import hyCommon from '@/locales/hy/common.json';
import hyAuth from '@/locales/hy/auth.json';
import hyDashboard from '@/locales/hy/dashboard.json';
import hyDevices from '@/locales/hy/devices.json';
import hyEmployees from '@/locales/hy/employees.json';
import hyReports from '@/locales/hy/reports.json';
import hyAdmin from '@/locales/hy/admin.json';
import hyErrors from '@/locales/hy/errors.json';
import hyHolidays from '@/locales/hy/holidays.json';
import hyNotifications from '@/locales/hy/notifications.json';
import hyLanding from '@/locales/hy/landing.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        dashboard: enDashboard,
        devices: enDevices,
        employees: enEmployees,
        reports: enReports,
        admin: enAdmin,
        errors: enErrors,
        holidays: enHolidays,
        notifications: enNotifications,
        landing: enLanding,
      },
      ru: {
        common: ruCommon,
        auth: ruAuth,
        dashboard: ruDashboard,
        devices: ruDevices,
        employees: ruEmployees,
        reports: ruReports,
        admin: ruAdmin,
        errors: ruErrors,
        holidays: ruHolidays,
        notifications: ruNotifications,
        landing: ruLanding,
      },
      hy: {
        common: hyCommon,
        auth: hyAuth,
        dashboard: hyDashboard,
        devices: hyDevices,
        employees: hyEmployees,
        reports: hyReports,
        admin: hyAdmin,
        errors: hyErrors,
        holidays: hyHolidays,
        notifications: hyNotifications,
        landing: hyLanding,
      },
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    supportedLngs: ['hy', 'ru', 'en'],
    nonExplicitSupportedLngs: true,
    detection: {
      // querystring first: ?lang=hy|ru|en gives the landing crawlable,
      // shareable language URLs (used by the hreflang alternates).
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'senseface.locale',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
